/* tslint:disable */
 
import { DataEntityField } from './data-entity-field';

/**
 * (tsType: Omit<DataEntityVersionChanges, >, schemaOptions: { exclude: [] })
 */
export class DataEntityVersionChanges {
  changeType: 'Field type changed' | 'Field restored from deleted but it breaks some rules' | 'Added required field' | 'Change field to required' | 'Added unique field' | 'Change field to unique' | 'Change field to repeated' | 'Change field to mulitvalue' | 'Entity workflow changed' | 'Enable deny circular relation on field' | 'Reference source changed';
  field?: DataEntityField;
  isBreaking: boolean;
}
